import { Component, Vue, Watch } from 'vue-property-decorator';
import moment from 'moment';
import SelectDropdown from '@/components/SelectDropdown.vue';
import changeAirport from '../../js/airport/changeAirport';

@Component({
    components: {
        SelectDropdown,
    },
    filters: {
        Date_MD(data: any) {
            return moment(data).format('MM-DD');
        },
        WeekDay(data: any) {
            moment.locale('zh-cn');
            return moment(data).format('dddd');
        },
        City(data: any) {
            return changeAirport.changeAirportCode(data).cityCName || '无';
        },
        AirPort(data: string) {
            return changeAirport.changeAirportCode(data).airportCName || '无';
        },
        AirLine(data: string) {
            return changeAirport.changeAirCompany(data) || '无';
        },
        ServiceLevel(data: string) {
            if (data === 'F') {
                return '头等舱';
            } else if (data === 'C') {
                return '商务舱';
            } else if (data === 'Y') {
                return '经济舱';
            }

        },
        DisCount(data: number) {
            return (data * 10).toFixed(1);
        },
    },
})
export default class AuditReason extends Vue {
    private $api: any;
    private isLoading: boolean = false;
    private Reasons: any = []; // 退改签原因数据源
    private reason: any = ''; // 选择的原因
    private Remark: any = ''; // 备注
    private trip: any = {}; // 列表页获取的行程信息
    private vm: any = {}; // 获取的订票信息
    private old: any = {}; // 改签时的旧机票信息
    private auditReasons: any = {}; // 员工自己的退改签原因
    private OperateReasons: any = []; // 其他修改的退改签原因
    private ReturnPay: any = ''; // 退改签费用

    private async created() {
        this.trip = JSON.parse(localStorage.getItem('tripInfo') || '');
        // 根据ID获取机票信息
        this.getTripInfo();
        // 获取退改签数据源
        this.getReasonSource();
        // 获取改签原因
        this.getReason();
    }
    // 获取机票信息
    private async getTripInfo() {
        this.$toast.loading({
            mask: true,
            message: '加载中...',
            duration: 0,
        });
        const model = {
            id: this.trip.Id,
        };
        const result = await this.$api.httpGet('basic/Ticket/QueryTicketInfoById', model);
        if (result.Success) {
            if (result.Data) {
                this.ReturnPay = result.Data.ReturnPay; // 退改签费用
                // 机票信息
                if (result.Data.NewTicket) {
                    this.vm = result.Data.NewTicket;
                }
                // 改签信息
                if (result.Data.OldTicket) {
                    this.old = result.Data.OldTicket;
                }
            }
            this.$toast.clear();
            this.isLoading = true;
        } else {
            this.$toast.clear();
            this.isLoading = true;
            this.$dialog.alert({
                message: result.AllMessages,
            });
        }
    }

    // 获取退改签原因数据源
    private async getReasonSource() {
        this.$toast.loading({
            mask: true,
            message: '加载中...',
            duration: 0,
        });
        const result = await this.$api.httpGet('Membership/TripInfo/GetReturnDataSourceOfReason');
        if (result.Success) {
            if (result.Data) {
                this.Reasons = result.Data.map((item: any) => {
                    return { id: item.Id, text: item.Value };
                });
            }
            this.$toast.clear();
            this.isLoading = true;
        } else {
            this.$toast.clear();
            this.isLoading = true;
            this.$dialog.alert({
                message: result.AllMessages,
            });
        }
    }

    // 获取退改签原因
    private async getReason() {
        if (this.trip.OperateType) {
            this.$toast.loading({
                mask: true,
                message: '加载中...',
                duration: 0,
            });
            const model = {
                UserTicketId: this.trip.Id,
                OperateType: this.trip.OperateType,
            };
            const result = await this.$api.httpPost('Membership/TripInfo/PostUserTicketReturnList', model);
            if (result.Success) {
                if (result.Data && result.Data.length > 0) {
                    result.Data.find((item: any, index: any) => {
                        if (item.OperateUserId === this.trip.UserId) {
                            item.ReturnReasonValue = item.ReturnReasonValue ? item.ReturnReasonValue : '无';
                            item.ReturnRemark = item.ReturnRemark ? item.ReturnRemark : '无';
                            this.auditReasons = item;
                            result.Data.splice(index, 1);
                            return;
                        }
                    });
                    this.OperateReasons = result.Data;
                }
                this.$toast.clear();
                this.isLoading = true;
            } else {
                this.$toast.clear();
                this.isLoading = true;
                this.$dialog.alert({
                    message: result.AllMessages,
                });
            }
        }
    }

    // 不修改，直接通过
    private async save() {
        this.$toast.loading({
            mask: true,
            message: '修改中...',
            duration: 0,
        });
        const model = {
            UserTicketId: this.trip.Id,
            ReturnReason: this.trip.ReturnReason,
            ReturnRemark: this.trip.ReturnRemark,
        };
        const result = await this.$api.httpPost('Membership/TripInfo/PostAduitUserTicketReturn', model);
        if (result.Success) {
            this.$toast.clear();
            this.isLoading = true;
            this.$toast.success('审核成功！');
            setTimeout(() => {
                this.$router.push('/tripinfo-list');
            }, 2000);
        } else {
            this.$toast.clear();
            this.isLoading = true;
            this.$dialog.alert({
                message: result.AllMessages,
            });
        }
    }
    
    // 确认修改
    private async saveChange() {
        this.$toast.loading({
            mask: true,
            message: '修改中...',
            duration: 0,
        });
        const model = {
            UserTicketId: this.trip.Id,
            ReturnReason: this.reason.id,
            ReturnRemark: this.Remark,
        };
        const result = await this.$api.httpPost('Membership/TripInfo/PostAduitUserTicketReturn', model);
        if (result.Success) {
            this.$toast.clear();
            this.isLoading = true;
            this.$toast.success('审核成功！');
            setTimeout(() => {
                this.$router.push('/tripinfo-list');
            }, 2000);
        } else {
            this.$toast.clear();
            this.isLoading = true;
            this.$dialog.alert({
                message: result.AllMessages,
            });
        }
    }

}
